"use client";

import { AnalyticsProvider } from "@repo/analytics/provider";
import { usePathname } from "next/navigation";
import { Suspense, type ReactNode } from "react";

export function PresentationPrivacy({ children }: { children: ReactNode }) {
  return <>{children}<Suspense fallback={null}><PresentationAnalytics /></Suspense></>;
}

function PresentationAnalytics() {
  const pathname = usePathname();
  if (/^\/presentations?\//.test(pathname ?? "")) return null;
  return <AnalyticsProvider>{null}</AnalyticsProvider>;
}
